import { injectable, inject } from 'inversify';
import Logger from '@framework/sentry/Logger';
import { Connection } from '@dealroadshow/socket-frontend-sdk';
import { PageRenderingState, PageRenderingStateValue } from '@framework/di';
import socketConfig from '@framework/config/socket';

@injectable()
class SocketConnection extends Connection {
  constructor(
    @inject(PageRenderingState) pageRenderingState: PageRenderingStateValue,
  ) {
    super(
      socketConfig.url,
      { autoConnect: pageRenderingState === PageRenderingStateValue.ClientSideRendering },
    );

    this.onConnect(() => {
      // @ts-ignore
      if (this.sockJs.transport === 'jsonp-polling') {
        Logger.info({ message: 'SockJS transport fell back to jsonp-polling usage. Please, check Sentry jsonp-polling errors.' });
      }
    });
  }
}

export default SocketConnection;
